<template>
  <div class="progress-wrapper">
    <div
      class="progress"
      :style="{
        height: height,
        backgroundColor: backgroundColor,
        boxShadow: 'inset -1px 3px 5px #bdbdbd'
      }">
      <!-- TODO: title -->
      <div
        v-for="(percent, idx) in normalizedPercents"
        class="progress-bar"
        role="progressbar"
        :key="'bar-inner-'+idx"
        @click="onClickBar(idx)"
        :style="{
          width: ( percent * 100 ) + '%',
          backgroundColor: colorMap[idx],
        }">
        <span class="progress-bar-text" v-if="showText">{{percents[idx]}}{{unit}}</span>
      </div>
      <div class="progress-bar-icons">
        <el-popover
          placement="left"
          width="200"
          v-model="popoverVisible">
          <div>Time tables</div>
          <ul class="progress-bar-inner">
            <li
              v-for="(percent, idx) in normalizedPercents"
              :key="'popover-inner-'+idx"
              @click="onClickBar(idx)"
              :style="{
                backgroundColor: colorMap[idx],
              }">
              {{percents[idx]}}{{unit}}
              ({{( Math.round(percent * 100) )}}%)
            </li>
          </ul>
          <el-switch
            size="small"
            v-model="maxValueOverride"
            active-text="Show unplanned"
            :active-value="false"
            :inactive-value="true"
            style="margin-bottom: 1em">
          </el-switch>
          <br />
          <el-button size="mini" @click="popoverVisible = false">cancel</el-button>
          <font-awesome-icon icon="wrench" slot="reference" />
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
// REQUIRES BOOTSTRAP

export default {
  props: {
    maxValue: {
      default: null
    },
    showText: {
      default: true
    },
    unit: {
      default: 'h'
    },
    height: {
      default: '3em'
    },
    percents: {
      default: []
    },
    backgroundColor: {
      default: "#e4e7ed"
    },
    colorMap: {
      default: () => ([
        'var(--orange)',
        'var(--danger)',
        'var(--lime)',
        'var(--green)',
        'var(--warning)',
        'var(--cyan)',
        'var(--red)',
        'var(--purple)',
        'var(--teal)',
        'var(--secondary)',
        'var(--indigo)',
        'var(--pink)',
        'var(--primary)',
        'var(--blue)',
        'var(--yellow)',
        'var(--info)',
        'var(--gray)',
        'var(--azure)',
        'var(--gray-dark)',
        'var(--wh)',
        'var(--success)',
      ])
    }
  },
  data() {
    return {
      popoverVisible: false,
      maxValueOverride: false
    }
  },
  computed: {
    normalizedPercents() {
      if ( this.percents.length === 0 ) {
        return [];
      }
      let percents = this.percents.map((val) => parseFloat(val));
      let sum = percents.reduce((total, val) => total + val) || 1;
      sum = this.maxValueOverride ? sum : ( this.maxValue || sum );
      let normalized = percents.map((val) => val / sum);
      // let normalizedToMaxValue = normalized.map((val) => val/this.maxValue);
      return normalized;
    }
  },
  methods: {
    onClickBar(idx) {
      // console.log("onClickBar", x);
      this.$emit('select', idx)
    },
  }
}
</script>

<style>
.progress-wrapper {
  padding: 0.1em;
}
.progress-wrapper .progress-bar:hover {
  opacity: 0.5;
}
.progress-wrapper .progress-bar {
  cursor: pointer;
}
.progress-bar-text {
  font-weight: bold;
  font-size: 10pt;
}
.progress-bar-icons {
  cursor: pointer;
  margin-right: 0.4em;
  position: absolute;
  top: 6px;
  right: 2px;
}
.progress-bar-inner {
  margin: 0;
  padding: 0.5em 0;
}
.progress-bar-inner li {
  list-style: none;
  margin: 3px 0;
  padding: 2px;
  color: white;
  border-radius: 2px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.4em;
  cursor: pointer;
}
.progress-bar-inner li:hover {
  opacity: 0.5;
}
</style>
